import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-mt-5" }
const _hoisted_2 = { class: "p-mt-3" }
const _hoisted_3 = { class: "p-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.registryDatatableWarningDialogDescriptor.dialog.style,
    header: _ctx.$t('documentExecution.registry.warning'),
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close', { stopWarnings: _ctx.stopWarnings, columnField: _ctx.columns[0].dependences })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.registry.column')) + " ", 1),
          _createVNode("b", null, _toDisplayString(_ctx.columnFileds), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('documentExecution.registry.warningDependences')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.stopWarnings,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopWarnings = $event)),
          binary: true
        }, null, 8, ["modelValue"]),
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('documentExecution.registry.warningCheckbox')), 1)
      ])
    ]),
    _: 1
  }, 8, ["style", "header", "visible"]))
}